/**
 * EmptyState — estado vacío estilo Apple.
 * Icono circular grande arriba (azul soft), título, subtítulo, y CTA opcional (pill azul).
 *
 * Uso:
 *   <EmptyState
 *     icon={<Calendar className="w-8 h-8 text-[#0071E3]" />}
 *     title="Sin citas para este día"
 *     description="Añade una nueva cita para comenzar."
 *     ctaLabel="Nueva cita"
 *     onCtaClick={() => setOpen(true)}
 *   />
 */
export default function EmptyState({
  icon,
  title,
  description,
  ctaLabel,
  onCtaClick,
  testid = "empty-state",
}) {
  return (
    <div
      className="flex flex-col items-center justify-center text-center py-12 px-6"
      data-testid={testid}
    >
      {icon && (
        <div className="w-16 h-16 rounded-full bg-[#0071E3]/[0.08] flex items-center justify-center mb-4">
          {icon}
        </div>
      )}
      <div className="text-[16px] font-semibold text-black">{title}</div>
      {description && (
        <div className="text-[13px] text-black/55 mt-1.5 max-w-[320px]">
          {description}
        </div>
      )}
      {ctaLabel && (
        <button
          type="button"
          onClick={onCtaClick}
          data-testid={`${testid}-cta`}
          className="mt-5 h-10 px-5 rounded-full bg-[#0071E3] hover:bg-[#0077ED] text-white text-[13.5px] font-semibold transition"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
